import { setIsLoading } from '../../../../actions/general';
import { callApi } from '../../../../apiCaller';
import { STATUS } from '../../../../constants';
import { toastError } from '../../../../utils';

export const SET_ALTERNATE_EMAILS_CONFIRM = 'setAlternateEmailConfirm';
export const API_SUBSCRIBER_ALTERNATE_EMAILS = 'alternate-email/by-email/:email';

export const setAlternateEmail = (alternateEmail) => {
     return {
          type: SET_ALTERNATE_EMAILS_CONFIRM,
          payload: alternateEmail,
     };
};

export const fetchAlternateEmailRequest = (email, navigate) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_ALTERNATE_EMAILS.replace(':email', email), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    if (response.data?.status === STATUS.ENABLE) {
                         navigate('/');
                    } else {
                         dispatch(setAlternateEmail(response.data));
                    }
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const confirmAlternateEmailSubmit = (email, emailPrimary, navigate) => (dispatch) => {
     callApi(API_SUBSCRIBER_ALTERNATE_EMAILS.replace(':email', emailPrimary), 'PUT', { email }).then((response) => {
          if (response.status === 200) {
               dispatch(setAlternateEmail(null));
               navigate('/', { replace: true });
          } else {
               toastError(response);
          }
     });
};
